<template>
   <v-expansion-panel
            class="mb-3 parent-expansion elevation-2  rounded-3 withRemove on-white-bg "
            style="position:relative">
                 <div class="horiz-left-coloured-bg">
                    <v-icon color="secondary" class="mt-0 ml-2 horiz-left-coloured-bg--icon">sync_alt</v-icon>
                </div>
              <v-expansion-panel-content class="rounded-3" v-if="linkedCaseType">
                <div slot="header">
                 <h3
                  class="text-truncate py-1 ml-2 pl-4 horiz-left-coloured-bg--padding-header">
          Relationship between
          <span style="font-weight:500">{{caseTypeName}}</span> template and the
          <span style="font-weight:500"> {{linkedCaseType.name}} </span>template
        </h3>
        <v-btn class="remove-icon" icon @click.stop >
          <v-icon color="error" @click="deleteDialog = true">cancel</v-icon>
        </v-btn>
      </div>
      <v-layout class="horiz-left-coloured-bg--padding">
      <form>
        <v-layout class="px-4 pt-0 pb-0 ">
          <v-flex
            xs12
            sm6
            mt-2
            :class="{'pr-0': $vuetify.breakpoint.mdAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp}">
            <h3 class="pb-2">Select a template</h3>
            <v-autocomplete
              box value="Claims"
              :items="caseTemplates"
              v-model="relation.toId"
              item-text="name"
              item-value="id"
              label="Template"
              no-data-text="No templates found"
              append-icon="keyboard_arrow_down"
              class="white-box-field"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
          <v-layout wrap class="px-4 pt-0 pb-0">
            <v-flex xs12>
              <h3 class="pb-2">Select related fields</h3>
            </v-flex>
            <v-flex xs12 sm6 :class="{'pr-0 chip-multiple-select': $vuetify.breakpoint.mdAndDown, 'pr-2 chip-multiple-select': $vuetify.breakpoint.mdAndUp}">
              <v-autocomplete
                :items="currentTemplateFields"
                v-model="relation.fromRelationKey"
                item-text="name"
                item-value="name"
                box
                class="white-box-field"
                chips
                :label="caseTypeName + ' field'"
                append-icon="keyboard_arrow_down"
                value="Title">
                <template slot="selection" slot-scope="data">
                  <v-chip class="white--text" color="secondary">{{ data.item.name }}</v-chip>
                </template>
                <template slot="item" slot-scope="data" class="test">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content class="dropdown-selected-tick">
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 :class="{'chip-multiple-select pl-0': $vuetify.breakpoint.mdAndDown, 'chip-multiple-select pl-2': $vuetify.breakpoint.mdAndUp}">
              <v-autocomplete
              class="white-box-field"
                :items="linkedTemplateFields"
                v-model="relation.toRelationKey"
                item-text="name"
                item-value="name"
                box chips
                :label="linkedCaseType.name + ' field'"
                append-icon="keyboard_arrow_down"
                value="Owner">
                <template slot="selection" slot-scope="data">
                  <v-chip class="white--text" color="secondary">{{ data.item.name }}</v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content class="dropdown-selected-tick">
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
            <v-layout wrap class="px-4 pt-0 pb-0">
              <v-flex xs12 class="chip-multiple-select">
                <h3 class="pb-2">Select relation display fields</h3>
                <v-autocomplete
                  class="white-box-field"
                  :items="linkedTemplateFields"
                  v-model="selectedFields"
                  @input="addDisplayField"
                  item-text="name"
                  item-value="value"
                  box
                  chips
                  label="Display fields"
                  multiple
                  append-icon="keyboard_arrow_down"
                  value="Owner">
                  <template v-slot:selection="data">
                    <v-chip
                      close
                      class="white--text"
                      @input="removeDisplayField(data.item)"
                      color="secondary">
                      {{ data.item.name }}
                  </v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content class="dropdown-selected-tick">
                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
        <v-layout wrap row class="pt-0 px-4 pb-4">
          <v-flex xs12 class="pt-1">
            <v-btn class="ml-0 mt-0 mr-2" color="success" @click="update()">Update Relationship</v-btn>
            <v-btn color="error" @click="deleteDialog = true" class="mt-0 ml-0">Delete</v-btn>
          </v-flex>
        </v-layout>
      </form>
      </v-layout>
      <delete-dialog :isOpen="deleteDialog" itemType="relationship" v-on:delete-item="deleteRelation"></delete-dialog>
    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
import DeleteDialog from "@/components/shared/deleteDialog"

export default {
  name: "relationship",
  props: { relation: Object, position: Number },
  components: { DeleteDialog },
  data() {
    return {
      fields: [],
      deleteDialog: false
    }
  },
  computed: {
    ...mapState({
      caseTypes: state => state.caseTypes.all,
      caseType: state => state.caseTypes.current
    }),
    caseTypeName() {
      if (this.caseType) { return this.caseType.displayName }
      return ""
    },
    currentTemplateFields() {
      if (this.caseType) {
        return this.getFields(this.caseType.id)
      }
      return []
    },
    linkedTemplateFields() {
      if (this.relation) {
        return this.getFields(this.relation.toId)
      }
      return []
    },
    selectedFields: {
      get() {
        const selectedFields = []
        const templateFields = this.linkedTemplateFields
        if (this.relation) {
          this.relation.fields.forEach(function(field) {
            let displayField
            if (templateFields) {
              displayField = templateFields.find((currentField) => (currentField.name === field.fieldName && currentField.header === undefined))
            }
            if (displayField) {
              displayField.value.id = field.id
              selectedFields.push(displayField)
            }
          })
        }
        return selectedFields
      },
      set(newField) {
        this.relation.fields.push(newField)
      }

    },
    caseTemplates() {
      if (this.caseTypes) {
        const cts = this.caseTypes.filter(caseType => caseType.id !== this.relation.fromId)
        cts.sort(function (a, b) {
          if (a.name < b.name) { return -1 }
          if (a.name > b.name) { return 1 }
          return 0
        })
        return cts
      }
      return []
    },
    linkedCaseType() {
      if (this.caseTypes && this.relation && this.relation.toId) {
        return this.caseTypes.find(ct => ct.id === this.relation.toId)
      }
      return undefined
    }
  },
  methods: {
    deleteRelation(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        this.$emit('delete-relationship', this.relation)
      }
    },
    getFields(id) {
      const caseType = Helpers.getCaseTypeById(this.$store.state, id)
      const fields = []
      fields.push({ header: "case_details" })
      fields.push({ name: "title", value: { field: "title", fieldset: "case_details" } })
      fields.push({ name: "created_at", value: { field: "created_at", fieldset: "case_details" } })
      fields.push({ name: "updated_at", value: { field: "updated_at", fieldset: "case_details" } })
      fields.push({ name: "last_exported_at", value: { field: "last_exported_at", fieldset: "case_details" } })
      fields.push({ name: "last_exported_via_bucket_id", value: { field: "last_exported_via_bucket_id", fieldset: "case_details" } })
      fields.push({ name: "sentiment_score", value: { field: "sentiment_score", fieldset: "case_details" } })
      fields.push({ name: "sentiment_magnitude", value: { field: "sentiment_magnitude", fieldset: "case_details" } })
      fields.push({ name: "no_unread_conversations", value: { field: "no_unread_conversations", fieldset: "case_details" } })
      fields.push({ name: "unresolved_task_failures", value: { field: "unresolved_task_failures", fieldset: "case_details" } })
      fields.push({ name: "current_state", value: { field: "current_state", fieldset: "case_details" } })
      fields.push({ name: "owner_name", value: { field: "owner_name", fieldset: "case_details" } })
      if (caseType && caseType.currentSchema && caseType.currentSchema.fieldsets) {
        caseType.currentSchema.fieldsets.forEach(function(fieldset) {
          if (fieldset.name !== "case_details" && fieldset.fields) {
            fields.push({ header: fieldset.name })
            fieldset.fields.forEach(function(field) {
              fields.push({ name: field.name, value: { field: field.name, fieldset: fieldset.name } })
            })
          }
        })
      }
      return fields
    },
    update() {
      if (this.relation) {
        const updateRelation = {
          id: this.relation.id,
          fromId: this.relation.fromId,
          toId: this.relation.toId,
          fromFieldsetKey: this.relation.fromFieldsetKey,
          toFieldsetKey: this.relation.toFieldsetKey,
          fromRelationKey: this.relation.fromRelationKey,
          toRelationKey: this.relation.toRelationKey,
          position: this.position
        }
        this.$store.dispatch("updateDirectRelationship", updateRelation)
      }
    },
    async addDisplayField(fields) {
      const field = fields[fields.length - 1]
      const result = await this.$store.dispatch("createDirectRelationshipDisplayField", { relationId: this.relation.id, fieldName: field.field })
      if (this.relation && !result.error) { this.relation.fields.push({ id: result.id, fieldName: field.field }) }
    },
    async removeDisplayField(field) {
      const response = await this.$store.dispatch("deleteDirectRelationshipDisplayField", { relationId: this.relation.id, id: field.value.id })
      if (!response.error) {
        const removeField = this.selectedFields.filter(obj => { return obj.name === field.name })
        const index = this.selectedFields.indexOf(removeField[0])
        if (index >= 0) this.selectedFields.splice(index, 1)
      }
    }
  }
}
</script>
